/* ET - Early Access: the landing-page signup, its countdown, and the mobile USP strip.

   The signup is the same machine as the closed page's: the same Klaviyo endpoint, the same
   message set, and the SAME localStorage key — an address signed up on either page is a known
   duplicate on both. */

(function () {
  var root = document.querySelector("[data-et-ea]");
  if (!root) return;

  var KLAVIYO_ENDPOINT = "https://a.klaviyo.com/client/subscriptions/";
  var KLAVIYO_REVISION = "2024-10-15";
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  // Shared with et-password-closed.js on purpose.
  var SEEN_KEY = "et-password-signup";
  var PENDING_KEY = "et-ea-signup-pending";

  function readSeen() {
    try {
      return JSON.parse(localStorage.getItem(SEEN_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function remember(email) {
    try {
      var seen = readSeen();
      if (seen.indexOf(email) === -1) seen.push(email);
      localStorage.setItem(SEEN_KEY, JSON.stringify(seen.slice(-20)));
    } catch (error) {
      /* Private mode: the signup still worked, only the duplicate hint is lost. */
    }
  }

  /* ------------------------------------------------------------- countdown: 02d : 07u : 32m */

  function initCountdown(el) {
    var target = Date.parse(el.dataset.target);

    if (isNaN(target)) {
      el.hidden = true;
      return;
    }

    var suffixes = (el.dataset.suffixes || "d,u,m,s").split(",");
    var fields = {
      days: el.querySelector('[data-et-ea-count="days"]'),
      hours: el.querySelector('[data-et-ea-count="hours"]'),
      minutes: el.querySelector('[data-et-ea-count="minutes"]'),
      seconds: el.querySelector('[data-et-ea-count="seconds"]'),
    };

    function pad(value) {
      return (value < 10 ? "0" : "") + value;
    }

    var timer = null;

    function tick() {
      var remaining = target - Date.now();

      if (remaining <= 0) {
        el.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }

      var total = Math.floor(remaining / 1000);
      if (fields.days) fields.days.textContent = pad(Math.floor(total / 86400)) + (suffixes[0] || "");
      if (fields.hours) fields.hours.textContent = pad(Math.floor(total / 3600) % 24) + (suffixes[1] || "");
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor(total / 60) % 60) + (suffixes[2] || "");
      if (fields.seconds) fields.seconds.textContent = pad(total % 60) + (suffixes[3] || "");
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------- signup */

  function initSignup() {
    var formView = root.querySelector('[data-et-ea-view="form"]');
    var successView = root.querySelector('[data-et-ea-view="success"]');
    var form = formView && formView.querySelector("form");
    var field = root.querySelector("[data-et-ea-email]");
    var errorBox = root.querySelector("[data-et-ea-error]");
    var errorText = root.querySelector("[data-et-ea-error-text]");

    if (!form || !field) return;

    var button = form.querySelector("button[type=submit]");
    var messages = root.dataset;

    function showError(message) {
      field.classList.add("et-early-access__input--invalid");
      if (errorText) errorText.textContent = message;
      if (errorBox) errorBox.hidden = !message;
    }

    function clearError() {
      field.classList.remove("et-early-access__input--invalid");
      if (errorBox) errorBox.hidden = true;
    }

    function showSuccess() {
      if (formView) formView.hidden = true;
      if (successView) successView.hidden = false;
    }

    field.addEventListener("input", clearError);

    // The Shopify form posts the page away; the reloaded page finds this marker.
    if (root.querySelector("[data-et-ea-posted]")) {
      try {
        sessionStorage.removeItem(PENDING_KEY);
      } catch (error) {
        /* nothing to clean */
      }
      showSuccess();
      return;
    }

    var serverError = root.querySelector("[data-et-ea-server-error]");
    if (serverError) {
      showError((serverError.dataset.etEaServerError || "").trim() || messages.msgError || "");
    }

    form.addEventListener("submit", function (event) {
      var email = field.value.trim();

      if (!EMAIL_PATTERN.test(email)) {
        event.preventDefault();
        showError(messages.msgInvalid || "");
        field.focus();
        return;
      }

      if (readSeen().indexOf(email.toLowerCase()) !== -1) {
        event.preventDefault();
        showError(messages.msgDuplicate || "");
        return;
      }

      clearError();

      if (root.dataset.mode !== "api") {
        try {
          sessionStorage.setItem(PENDING_KEY, email);
        } catch (error) {
          /* The success view simply renders without it. */
        }
        return;
      }

      event.preventDefault();
      if (button) button.disabled = true;

      fetch(KLAVIYO_ENDPOINT + "?company_id=" + encodeURIComponent(root.dataset.publicKey), {
        method: "POST",
        headers: {
          "content-type": "application/json",
          revision: KLAVIYO_REVISION,
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: { data: { type: "profile", attributes: { email: email } } },
            },
            relationships: {
              list: { data: { type: "list", id: root.dataset.listId } },
            },
          },
        }),
      })
        .then(function (response) {
          // Klaviyo answers 202 Accepted with an empty body on success.
          if (response.ok) {
            remember(email.toLowerCase());
            showSuccess();
          } else {
            showError(messages.msgError || "");
          }
        })
        .catch(function () {
          showError(messages.msgError || "");
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    });
  }

  /* ------------------------------------------------------------- mobile USP strip */

  function initUsps() {
    var strip = root.querySelector("[data-et-ea-usps]");
    if (!strip) return;

    var items = Array.prototype.slice.call(strip.querySelectorAll("[data-et-ea-usp]"));
    if (!items.length) return;

    var index = 0;

    function show(next) {
      index = (next + items.length) % items.length;
      items.forEach(function (item, i) {
        item.classList.toggle("is-active", i === index);
      });
    }

    show(0);

    var prev = strip.querySelector("[data-et-ea-usp-prev]");
    var next = strip.querySelector("[data-et-ea-usp-next]");
    if (prev) prev.addEventListener("click", function () { show(index - 1); });
    if (next) next.addEventListener("click", function () { show(index + 1); });
  }

  var countdown = root.querySelector("[data-et-ea-countdown]");
  if (countdown) initCountdown(countdown);
  initSignup();
  initUsps();
})();
